<template>
  <div class="wrap">
    <button class="sig" @click="openLinkedInAuth">
      <div class='ico-wrapper'>
        <svg class="ico" viewBox="0 0 40 40" version="1.1">
          <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">
            <g id="LinkedIn" sketch:type="MSArtboardGroup" fill="#FFFFFF">
              <g id="Fill-6-+-Fill-7" sketch:type="MSLayerGroup" transform="translate(6.000000, 5.000000)">
                <path d="M3.44222222,0 C5.34,0 6.88,1.54111111 6.88,3.44 C6.88,5.34 5.34,6.88111111 3.44222222,6.88111111 C1.53666667,6.88111111 0,5.34 0,3.44 C0,1.54111111 1.53666667,0 3.44222222,0 L3.44222222,0 Z M0.471111111,9.48888889 L6.41,9.48888889 L6.41,28.5777778 L0.471111111,28.5777778 L0.471111111,9.48888889 Z"
                id="Fill-6" sketch:type="MSShapeGroup"></path>
                <path d="M10,9.47333333 L15.6866667,9.47333333 L15.6866667,12.0833333 L15.7688889,12.0833333 C16.56,10.5822222 18.4955556,9 21.3811111,9 C27.3888889,9 28.4988889,12.9522222 28.4988889,18.0933333 L28.4988889,28.5622222 L22.5666667,28.5622222 L22.5666667,19.2788889 C22.5666667,17.0655556 22.5288889,14.2177778 19.4844444,14.2177778 C16.3966667,14.2177778 15.9255556,16.63 15.9255556,19.1211111 L15.9255556,28.5622222 L10,28.5622222 L10,9.47333333"
                id="Fill-7" sketch:type="MSShapeGroup"></path>
              </g>
            </g>
          </g>
        </svg>
      </div>
      <div class="label">
        {{ buttonLabel }}
      </div>
    </button>
  </div>
</template>

<script>
import api from '@/api'
import { mapState } from 'vuex';
export default {
  props: {
    buttonLabel: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      randomString: ''
    }
  },
  computed: {
    ...mapState(['fairConfig'])
  },
  mounted () {
    this.getRandomString();
  },
  methods: {
    openLinkedInAuth () {
      let redirectUrl = `${window.location.origin}/linkedin`
      window.location.replace(`
        https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${this.fairConfig.LN_CLIENT_ID}&redirect_uri=${redirectUrl}&state=${this.randomString}&scope=r_liteprofile%20r_emailaddress
      `);
    },
    async getRandomString () {
      let apiObj = {
        api: api.getRandomString,
        params: {
          size: 20
        }
      }
      const data = await this.apiCall(apiObj);
      this.randomString = data.result
    }
  },
}
</script>

<style lang="scss" scoped>
.sig {
  display: flex;
  align-items: center;
  position: relative;
  box-sizing: border-box;
  height: 40px;
  width: 100%;
  background-color: #0077b5;
  font: 800 14px/40px Roboto;
  letter-spacing: 0.65px;
  color: white;
  border-radius: 4px;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, .24);
  overflow: hidden;
  outline: none;
  border: none;
  padding: 0;
  cursor: pointer;
}

.sig:hover {
  background-color: #0369a0;
  box-shadow: 0 2px 0 rgba(0, 0, 0, .12);
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, .24);
}

.sig:active {
  background-color: #066093;
}

.ico-wrapper {
  width: 40px;
  height: 40px;
  background-color: #0B78B7;
  border: 1px solid #085B8C;
  border-radius: 5px;
  box-sizing: border-box;
  svg {
    width: 100%;
    height: 100%;
  }
}

.label {
  width: calc(100% - 40px);
  display: flex;
  justify-content: center;
}
</style>